import React, { useMemo } from 'react';
import {IServerStatistics, serverStatisticsSelector} from '../../../../../../../libs/redux';
import { useSelector, shallowEqual } from 'react-redux';
import styled, { keyframes, Keyframes } from 'styled-components';
import {getRandom} from '../../../../../../../resources/api';
import {fadeIn} from 'react-animations';
  
const fadeinAnimation = keyframes`${fadeIn}`;
interface StyledProps {
  animation : Keyframes
}
const Animation = styled.div`
    animation: 1s ${(props : StyledProps) => props.animation};
`;

const ListCardContainer : React.FC<{Component: any}> = ({Component}) => {

    const items = useSelector(serverStatisticsSelector, shallowEqual);

    const itemList = useMemo(() => {
        if(!items) return [];
        return Object.values(items);
    }, [items]);

    return useMemo(()=>  (
        <div className="flex w-full flex-col overflow-y-auto scrolleable">
          <Animation key={getRandom()} animation = {fadeinAnimation}>
            {itemList.sort((itemA: IServerStatistics, itemB: IServerStatistics)=> 
            {
              if(itemA.avgAmount !== null && itemB.avgAmount !== null) {
                return itemB.avgAmount - itemA.avgAmount;
              }
              return itemB.rating - itemA.rating;
            }
            ).map((item: IServerStatistics) =><Component key={item.id} {...item} onClick={() => {}}/>)}
          </Animation>
        </div>
      )
,[itemList])
};

export default ListCardContainer;